import { createWebHistory, createRouter } from "vue-router";

export default createRouter({
    history: createWebHistory(),
    routes: [{
        path: "/pagar/:codigo", name: "checkoutPagamento",
        meta: { public: true, requiresAuth: false, layout: "checkout" },
        component: () => import(/* webpackChunkName: "checkout" */ "@/views/CheckoutPagamento.vue")
    }, {
        path: "/payLinks", name: "payLinks",
        meta: { requiresAuth: true, title: "Links de pagamento" },
        component: () => import(/* webpackChunkName: "payLinks" */ "@/pages/PayLinks.vue")
    }, {
        path: "/display/consultorio", 
        name: "DisplayConsultorio", 
        meta: {
            public: true, 
            requiresAuth: false, 
            layout: "display"
        }, 
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/DisplayConsultorio.vue")
    }, {
        path: "/validador", 
        name: "ValidadorDocumento", 
        meta: {
            public: true, 
            requiresAuth: false, 
            layout: "display"
        }, 
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/ValidadorDocumento.vue")
    }, {
        path: "/", 
        redirect: "/dashboard", 
        meta: {
            requiresAuth: true
        }
    }, {
        path: "/dashboard", 
        name: "dashboard", 
        meta: {
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "dashboard" */ "@/pages/DashboardAnalytics.vue")
    }, {
        path: "/indicadores",
        name: "indicadores",
        meta: { title: "Indicadores", requiresAuth: true },
        component: () => import(/* webpackChunkName: "indicadores" */ "@/pages/IndicadoresAnalytics.vue")
    }, {
        path: "/totemFuncionario", 
        name: "totemFuncionario", 
        meta: {
            title: "Totem manipulado pelo Funcionário", 
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "totemFuncionario" */ "@/pages/TotemFuncionario.vue")
    }, {
        path: "/totemPaciente",
        name: "totemPaciente",
        meta: {
            title: "Totem manipulado pelo Paciente", 
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "totemPaciente" */ "@/pages/TotemPaciente.vue")
    }, {
        path: "/chamadaNaTV",
        name: "chamadaNaTV",
        meta: {
            title: "Chamada na TV", 
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "chamadaNaTV" */ "@/pages/ChamadaNaTV.vue")
    }, {
        path: "/agenda", 
        name: "agenda", 
        meta: {
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "agenda" */ "@/pages/AgendaSpirit.vue")
    }, {
        path: "/agendaGoogle",
        name: "agendaGoogle",
        meta: {
            title: "Calendário", 
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "agendaGoogle" */ "@/pages/AgendaSpirit.vue")
    }, {
        path: "/filaPep", 
        name: "filaPep", 
        meta: {
            title: "Fila do Prontuário Eletrônico do Paciente (PEP)", 
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "filaPep" */ "@/pages/FilaPEP.vue")
    }, {
        path: "/filaLaudo", 
        name: "filaLaudo", 
        meta: {
            title: "Fila do Prontuário Eletrônico do Paciente (PEP)", 
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "filaLaudo" */ "@/pages/FilaPEP.vue")
    }, {
        path: "/filaExames", 
        name: "filaExames", 
        meta: {
            title: "Fila de Exames do Prontuário Eletrônico do Paciente (PEP)", 
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "filaExames" */ "@/pages/FilaPEP.vue")
    }, {
        path: "/repasse",
        name: "repasse",
        meta: {
            title: "Repasse Médico", 
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "repasse" */ "@/pages/RepasseMedico.vue")
    }, {
        path: "/gestaoDeRetorno", 
        name: "gestaoDeRetorno", 
        meta: {
            title: "Gestão de Retorno", 
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "repasse" */ "@/pages/AgendaRetorno.vue")
    }, {
        path: "/solicitacaoProcedimento", 
        name: "solicitacaoProcedimento", 
        meta: {
            title: "Solicitação de Procedimento", 
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "repasse" */ "@/pages/SolicitacaoProcedimento.vue")
    }, {
        path: "/pep/:id",
        name: "pep",
        meta: {
            title: "Prontuário Eletrônico do Paciente (PEP)", 
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "pep" */ "@/pages/ProntuarioEletronico.vue")
    }, {
        path: "/pep/:id/:idAgenda",
        name: "pepComAgenda",
        meta: {
            title: "Prontuário Eletrônico do Paciente (PEP)", 
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "pepComAgenda" */ "@/pages/ProntuarioEletronico.vue")
    }, {
        path: "/pep/:id/:idAgenda/:idAgendaExame/:idProduto",
        name: "pepLaudo",
        meta: {
            title: "Prontuário Eletrônico do Paciente (PEP)", 
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "pepLaudo" */ "@/pages/ProntuarioEletronico.vue")
    }, {
        path: "/pep/:id/:idAgenda/:idAgendaExame/:idProduto/:idDiversos",
        name: "pepLaudoAlteracao",
        meta: {
            title: "Prontuário Eletrônico do Paciente (PEP)", 
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "pepLaudoAlteracao" */ "@/pages/ProntuarioEletronico.vue")
    }, {
        path: "/pepNovaAba/:id",
        name: "pepNovaAba",
        meta: {
            title: "Prontuário Eletrônico do Paciente (PEP)", 
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "pep" */ "@/pages/ProntuarioEletronico.vue")
    }, {
        path: "/pepNovaAba/:id/:idAgenda",
        name: "pepNovaAbaComAgenda",
        meta: {
            title: "Prontuário Eletrônico do Paciente (PEP)", 
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "pepComAgenda" */ "@/pages/ProntuarioEletronico.vue")
    }, {
        path: "/pepNovaAba/:id/:idAgenda/:idAgendaExame/:idProduto",
        name: "pepNovaAbaLaudo",
        meta: {
            title: "Prontuário Eletrônico do Paciente (PEP)", 
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "pepLaudo" */ "@/pages/ProntuarioEletronico.vue")
    }, {
        path: "/pepNovaAba/:id/:idAgenda/:idAgendaExame/:idProduto/:idDiversos",
        name: "pepNovaAbaLaudoAlteracao",
        meta: {
            title: "Prontuário Eletrônico do Paciente (PEP)", 
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "pepLaudoAlteracao" */ "@/pages/ProntuarioEletronico.vue")
    }, {
        path: "/textos",
        name: "textos",
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "textos" */ "@/pages/CadTextos.vue")
    }, {
        path: "/texto", 
        name: "textoInc", 
        meta: {
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "textoInc" */ "@/pages/CadTexto.vue")
    }, {
        path: "/texto/:id",
        name: "textoAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "textoAlt" */ "@/pages/CadTexto.vue")
    }, {
        path: "/textosEmail",
        name: "textosEmail", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "textosEmail" */ "@/pages/CadTextosEmail.vue")
    }, {
        path: "/textoEmail",
        name: "textoEmailInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "textoEmailInc" */ "@/pages/CadTextoEmail.vue")
    }, {
        path: "/textoEmail/:id",
        name: "textoEmailAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "textoEmailAlt" */ "@/pages/CadTextoEmail.vue")
    }, {
        path: "/turnos",
        name: "turnos", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "turnos" */ "@/pages/CadTurnos.vue")
    }, {
        path: "/turno",
        name: "turnoInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "turnoInc" */ "@/pages/CadTurno.vue")
    }, {
        path: "/turno/:id",
        name: "turnoAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "turnoAlt" */ "@/pages/CadTurno.vue")
    }, {
        path: "/unidades",
        name: "unidades", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "unidades" */ "@/pages/CadUnidades.vue")
    }, {
        path: "/unidade",
        name: "unidadeInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "unidadeInc" */ "@/pages/CadUnidade.vue")
    }, {
        path: "/unidade/:id",
        name: "unidadeAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "unidadeAlt" */ "@/pages/CadUnidade.vue")
    }, {
        path: "/staffMedicos",
        name: "staffMedicos",
        meta: {
            title: "Inclusão Cadastro Staff Médico", 
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "staffMedicos" */ "@/pages/CadStaffMedicos.vue")
    }, {
        path: "/staffMedico",
        name: "staffMedicoInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "staffMedicoInc" */ "@/pages/CadStaffMedico.vue")
    }, {
        path: "/staffMedico/:id",
        name: "staffMedicoAlt",
        meta: {
            title: "Alteração Cadastro Staff Médico", 
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "staffMedicoAlt" */ "@/pages/CadStaffMedico.vue")
    }, {
        path: "/staffMedicosCategorias",
        name: "staffMedicosCategorias", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "staffMedicosCategorias" */ "@/pages/CadStaffMedicosCategorias.vue")
    }, {
        path: "/staffMedicoCategoria",
        name: "staffMedicoCategoriaInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "staffMedicoCategoriaInc" */ "@/pages/CadStaffMedicoCategoria.vue")
    }, {
        path: "/staffMedicoCategoria/:id",
        name: "staffMedicoCategoriaAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "staffMedicoCategoriaAlt" */ "@/pages/CadStaffMedicoCategoria.vue")
    }, {
        path: "/contatosExternos",
        name: "contatosExternos", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "contatosExternos" */ "@/pages/CadContatosExternos.vue")
    }, {
        path: "/contatoExterno",
        name: "contatoExternoInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "contatoExternoInc" */ "@/pages/CadContatoExterno.vue")
    }, {
        path: "/contatoExterno/:id",
        name: "contatoExternoAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "contatoExternoAlt" */ "@/pages/CadContatoExterno.vue")
    }, {
        path: "/servicos",
        name: "servicos", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "servicos" */ "@/pages/CadServicos.vue")
    }, {
        path: "/servico",
        name: "servicoInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "servicoInc" */ "@/pages/CadServico.vue")
    }, {
        path: "/servico/:id",
        name: "servicoAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "servicoAlt" */ "@/pages/CadServico.vue")
    }, {
        path: "/procedimentos",
        name: "procedimentos", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "procedimentos" */ "@/pages/CadProcedimentos.vue")
    }, {
        path: "/procedimento",
        name: "procedimentoInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "procedimentoInc" */ "@/pages/CadProcedimento.vue")
    }, {
        path: "/procedimento/:id",
        name: "procedimentoAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "procedimentoAlt" */ "@/pages/CadProcedimento.vue")
    }, {
        path: "/produtos",
        name: "produtos", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "produtos" */ "@/pages/CadProdutos.vue")
    }, {
        path: "/produto",
        name: "produtoInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "produtoInc" */ "@/pages/CadProduto.vue")
    }, {
        path: "/produto/:id",
        name: "produtoAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "produtoAlt" */ "@/pages/CadProduto.vue")
    }, {
        path: "/pacientes",
        name: "pacientes", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "pacientes" */ "@/pages/CadPacientes.vue")
    }, {
        path: "/paciente",
        name: "pacienteInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "pacienteInc" */ "@/pages/CadPaciente.vue")
    }, {
        path: "/paciente/:id",
        name: "pacienteAlt",
        meta: {
            title: "Cadastro do Paciente", 
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "pacienteAlt" */ "@/pages/CadPaciente.vue")
    }, {
        path: "/convenios",
        name: "convenios", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "convenios" */ "@/pages/CadConvenios.vue")
    }, {
        path: "/convenio",
        name: "convenioInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "convenioInc" */ "@/pages/CadConvenio.vue")
    }, {
        path: "/convenio/:id",
        name: "convenioAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "convenioAlt" */ "@/pages/CadConvenio.vue")
    }, {
        path: "/usuarios",
        name: "usuarios", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "usuarios" */ "@/pages/CadUsuarios.vue")
    }, {
        path: "/usuario",
        name: "usuarioInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "usuarioInc" */ "@/pages/CadUsuario.vue")
    }, {
        path: "/usuario/:id",
        name: "usuarioAlt",
        meta: {
            title: "Alteração de Usuário", 
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "usuarioAlt" */ "@/pages/CadUsuario.vue")
    }, {
        path: "/perfil",
        name: "perfil", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "perfil" */ "@/pages/UsuarioPerfil.vue")
    }, {
        path: "/locaisAtendimentoCategorias",
        name: "locaisAtendimentoCategorias", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "locaisAtendimentoCategorias" */ "@/pages/CadLocaisAtendimentoCategorias.vue")
    }, {
        path: "/localAtendimentoCategoria",
        name: "localAtendimentoCategoriaInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "localAtendimentoCategoriaInc" */ "@/pages/CadLocalAtendimentoCategoria.vue")
    }, {
        path: "/localAtendimentoCategoria/:id",
        name: "localAtendimentoCategoriaAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "localAtendimentoCategoriaAlt" */ "@/pages/CadLocalAtendimentoCategoria.vue")
    }, {
        path: "/categoriasTextos",
        name: "categoriasTextos", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "categoriasTextos" */ "@/pages/CadCategoriasTextos.vue")
    }, {
        path: "/categoriaTexto",
        name: "categoriaTextoInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "categoriaTextoInc" */ "@/pages/CadCategoriaTexto.vue")
    }, {
        path: "/categoriaTexto/:id",
        name: "categoriaTextoAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "categoriaTextoAlt" */ "@/pages/CadCategoriaTexto.vue")
    }, {
        path: "/configuracoes",
        name: "configuracoes", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "configuracoes" */ "@/pages/ConfiguracoesSistema.vue")
    }, {
        path: "/redirect/:rota",
        name: "redirect", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "redirect" */ "@/pages/ComponentRedirect.vue")
    }, {
        path: "/locais",
        name: "locais", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "locais" */ "@/pages/CadLocais.vue")
    }, {
        path: "/local",
        name: "localInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "localInc" */ "@/pages/CadLocal.vue")
    }, {
        path: "/local/:id",
        name: "localAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "localAlt" */ "@/pages/CadLocal.vue")
    }, {
        path: "/tabelasPrecos",
        name: "tabelasPrecos", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "tabelasPrecos" */ "@/pages/CadTabelasPrecos.vue")
    }, {
        path: "/tabelaPreco",
        name: "tabelaPrecoInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "tabelaPrecoInc" */ "@/pages/CadTabelaPreco.vue")
    }, {
        path: "/tabelaPreco/:id",
        name: "tabelaPrecoAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "tabelaPrecoAlt" */ "@/pages/CadTabelaPreco.vue")
    }, {
        path: "/classificacaoGuias",
        name: "classificacaoGuias", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "classificacaoGuias" */ "@/pages/CadClassificacaoGuias.vue")
    }, {
        path: "/classificacaoGuia",
        name: "classificacaoGuiaInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "classificacaoGuiaInc" */ "@/pages/CadClassificacaoGuia.vue")
    }, {
        path: "/classificacaoGuia/:id",
        name: "classificacaoGuiaAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "classificacaoGuiaAlt" */ "@/pages/CadClassificacaoGuia.vue")
    }, {
        path: "/classificacaoAtendimentos",
        name: "classificacaoAtendimentos", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "classificacaoAtendimentos" */ "@/pages/CadClassificacaoAtendimentos.vue")
    }, {
        path: "/classificacaoAtendimento",
        name: "classificacaoAtendimentoInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "classificacaoAtendimentoInc" */ "@/pages/CadClassificacaoAtendimento.vue")
    }, {
        path: "/classificacaoAtendimento/:id",
        name: "classificacaoAtendimentoAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "classificacaoAtendimentoAlt" */ "@/pages/CadClassificacaoAtendimento.vue")
    }, {
        path: "/orcamentoPaciente",
        name: "orcamentoPaciente",
        meta: { requiresAuth: true, title: "Orçamentos de Pacientes" },
        component: () => import(/* webpackChunkName: "orcamentoPaciente" */ "@/pages/orcamentoPaciente.vue")
    }, {
        path: "/orcamentoPaciente/agenda/:idPacienteAgenda(\\d+)/:idAgenda(\\d+)?",
        name: "orcamentoPacienteAgenda",
        props: true,
        meta: { requiresAuth: true, title: "Orçamentos de Pacientes" },
        component: () => import(/* webpackChunkName: "orcamentoPaciente" */ "@/pages/orcamentoPaciente.vue")
    }, {
        path: "/contasPaciente",
        name: "contasPaciente", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "contasPaciente" */ "@/pages/ContasPaciente.vue")
    }, {
        path: "/contasPaciente/:idAgenda",
        name: "contasPacienteAgenda", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "contasPaciente" */ "@/pages/ContasPaciente.vue")
    }, {
        path: "/fluxoDeCaixa",
        name: "fluxoDeCaixa", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "fluxoDeCaixa" */ "@/pages/FluxoDeCaixa.vue")
    }, {
        path: "/fluxoDeCaixa/pagar",
        name: "fluxoDeCaixaPagar",
        meta: { requiresAuth: true },
        props: { tipoFixo: "P" },
        component: () => import(/* webpackChunkName: "fluxoDeCaixa" */ "@/pages/FluxoDeCaixa.vue")
    }, {
        path: "/fluxoDeCaixa/receber",
        name: "fluxoDeCaixaReceber",
        meta: { requiresAuth: true },
        props: { tipoFixo: "R" },
        component: () => import(/* webpackChunkName: "fluxoDeCaixa" */ "@/pages/FluxoDeCaixa.vue")
    }, {
        path: "/portadoresMovimentacao",
        name: "portadoresMovimentacao", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "portadoresMovimentacao" */ "@/pages/PortadoresMovimentacao.vue")
    }, {
        path: "/empresas", 
        name: "empresas", 
        meta: {
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "empresas" */ "@/pages/CadEmpresas.vue")
    }, {
        path: "/empresaInc", 
        name: "empresaInc", 
        meta: {
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "empresas" */ "@/pages/CadEmpresa.vue")
    }, {
        path: "/empresa/:id", 
        name: "empresa", 
        meta: {
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "empresas" */ "@/pages/CadEmpresa.vue")
    }, {
        path: "/medicamentosPersonalizados", 
        name: "medicamentosPersonalizados", 
        meta: {
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "medicamentosPersonalizados" */ "@/pages/CadMedicamentosPersonalizados.vue")
    }, {
        path: "/medicamentoPersonalizadoInc", 
        name: "medicamentoPersonalizadoInc", 
        meta: {
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "medicamentosPersonalizados" */ "@/pages/CadMedicamentoPersonalizado.vue")
    }, {
        path: "/medicamentoPersonalizado/:id", 
        name: "medicamentoPersonalizado", 
        meta: {
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "medicamentosPersonalizados" */ "@/pages/CadMedicamentoPersonalizado.vue")
    }, {
        path: "/medicamentosPosologias",
        name: "medicamentosPosologias", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "medicamentosPosologias" */ "@/pages/CadMedicamentosPosologias.vue")
    }, {
        path: "/medicamentosSubstitutos",
        name: "medicamentosSubstitutos", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "medicamentosSubstitutos" */ "@/pages/CadMedicamentosSubstitutos.vue")
    }, {
        path: "/emitentesCategorias", 
        name: "emitentesCategorias", 
        meta: {
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "emitentesCategorias" */ "@/pages/CadEmitentesCategorias.vue")
    }, {
        path: "/emitenteCategoriaInc", 
        name: "emitenteCategoriaInc", 
        meta: {
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "emitentesCategorias" */ "@/pages/CadEmitenteCategoria.vue")
    }, {
        path: "/emitenteCategoria/:id", 
        name: "emitenteCategoria", 
        meta: {
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "emitentesCategorias" */ "@/pages/CadEmitenteCategoria.vue")
    }, {
        path: "/especialidades", 
        name: "especialidades", 
        meta: {
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "especialidades" */ "@/pages/CadEspecialidades.vue")
    }, {
        path: "/especialidadeInc", 
        name: "especialidadeInc", 
        meta: {
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "especialidades" */ "@/pages/CadEspecialidade.vue")
    }, {
        path: "/especialidade/:id", 
        name: "especialidade", 
        meta: {
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "especialidades" */ "@/pages/CadEspecialidade.vue")
    }, {
        path: "/produtosCategorias", 
        name: "produtosCategorias", 
        meta: {
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "produtosCategorias" */ "@/pages/CadProdutosCategorias.vue")
    }, {
        path: "/produtoCategoriaInc", 
        name: "produtoCategoriaInc", 
        meta: {
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "produtosCategorias" */ "@/pages/CadProdutoCategoria.vue")
    }, {
        path: "/produtoCategoria/:id", 
        name: "produtoCategoria", 
        meta: {
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "produtosCategorias" */ "@/pages/CadProdutoCategoria.vue")
    }, {
        path: "/produtosUnidades", 
        name: "produtosUnidades", 
        meta: {
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "produtosUnidades" */ "@/pages/CadProdutosUnidades.vue")
    }, {
        path: "/produtoUnidadeInc", 
        name: "produtoUnidadeInc", 
        meta: {
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "produtosUnidades" */ "@/pages/CadProdutoUnidade.vue")
    }, {
        path: "/produtoUnidade/:id", 
        name: "produtoUnidade", 
        meta: {
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "produtosUnidades" */ "@/pages/CadProdutoUnidade.vue")
    }, {
        path: "/produtosMarcas", 
        name: "produtosMarcas", 
        meta: {
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "produtosMarcas" */ "@/pages/CadProdutosMarcas.vue")
    }, {
        path: "/produtoMarcaInc", 
        name: "produtoMarcaInc", 
        meta: {
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "produtosMarcas" */ "@/pages/CadProdutoMarca.vue")
    }, {
        path: "/produtoMarca/:id", 
        name: "produtoMarca", 
        meta: {
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "produtosMarcas" */ "@/pages/CadProdutoMarca.vue")
    }, {
        path: "/centrosResponsabilidade",
        name: "centrosResponsabilidade", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "centrosResponsabilidade" */ "@/pages/CadCentrosResponsabilidade.vue")
    }, {
        path: "/centroResponsabilidade",
        name: "centroResponsabilidadeInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "centroResponsabilidadeInc" */ "@/pages/CadCentroResponsabilidade.vue")
    }, {
        path: "/centroResponsabilidade/:id",
        name: "centroResponsabilidadeAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "centroResponsabilidadeAlt" */ "@/pages/CadCentroResponsabilidade.vue")
    }, {
        path: "/portadores",
        name: "portadores", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "portadores" */ "@/pages/CadPortadores.vue")
    }, {
        path: "/portador",
        name: "portadorInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "portadorInc" */ "@/pages/CadPortador.vue")
    }, {
        path: "/portador/:id",
        name: "portadorAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "portadorAlt" */ "@/pages/CadPortador.vue")
    }, {
        path: "/planosFinanceiros",
        name: "planosFinanceiros", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "planosFinanceiros" */ "@/pages/CadPlanosFinanceiros.vue")
    }, {
        path: "/planoFinanceiro",
        name: "planoFinanceiroInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "planoFinanceiroInc" */ "@/pages/CadPlanoFinanceiro.vue")
    }, {
        path: "/planoFinanceiro/:id",
        name: "planoFinanceiroAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "planoFinanceiroAlt" */ "@/pages/CadPlanoFinanceiro.vue")
    }, {
        path: "/fichasDeDados",
        name: "fichasDeDados", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "fichasDeDados" */ "@/pages/CadFichasDeDados.vue")
    }, {
        path: "/fichaDeDados",
        name: "fichaDeDadosInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "fichaDeDadosInc" */ "@/pages/CadFichaDeDados.vue")
    }, {
        path: "/fichaDeDados/:id",
        name: "fichaDeDadosAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "fichaDeDadosAlt" */ "@/pages/CadFichaDeDados.vue")
    }, {
        path: "/projetos",
        name: "projetos", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "projetos" */ "@/pages/CadProjetos.vue")
    }, {
        path: "/projeto",
        name: "projetoInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "projetoInc" */ "@/pages/CadProjeto.vue")
    }, {
        path: "/projeto/:id",
        name: "projetoAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "projetoAlt" */ "@/pages/CadProjeto.vue")
    }, {
        path: "/transacoesRecorrentes",
        name: "transacoesRecorrentes", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "transacoesRecorrentes" */ "@/pages/CadTransacoesRecorrentes.vue")
    }, {
        path: "/transacaoRecorrente",
        name: "transacaoRecorrenteInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "transacaoRecorrenteInc" */ "@/pages/CadTransacaoRecorrente.vue")
    }, {
        path: "/transacaoRecorrente/:id",
        name: "transacaoRecorrenteAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "transacaoRecorrenteAlt" */ "@/pages/CadTransacaoRecorrente.vue")
    }, {
        path: "/relatorioProjetadoAgendaSemanal",
        name: "relatorioProjetadoAgendaSemanal",
        meta: {
            title: "Fluxo Projetado da Agenda Semanal",
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "relatorioProjetadoAgendaSemanal" */ "@/pages/RelatorioProjetadoAgendaSemanal.vue")
    }, {
        path: "/relatorioProjetadoDiario",
        name: "relatorioProjetadoDiario",
        meta: {
            title: "Projetado Diário por Emitente",
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "relatorioProjetadoDiario" */ "@/pages/RelatorioProjetadoDiario.vue")
    }, {
        path: "/relatorioDRE", 
        name: "relatorioDRE", 
        meta: {
            title: "Relatório de DRE", 
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "relatorioDRE" */ "@/pages/RelatorioDRE.vue")
    }, {
        path: "/profissoes",
        name: "profissoes", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "profissoes" */ "@/pages/CadProfissoes.vue")
    }, {
        path: "/profissao",
        name: "profissaoInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "profissaoInc" */ "@/pages/CadProfissao.vue")
    }, {
        path: "/profissao/:id",
        name: "profissaoAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "profissaoAlt" */ "@/pages/CadProfissao.vue")
    }, {
        path: "/tiposOcorrencias",
        name: "tiposOcorrencias", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "tiposOcorrencias" */ "@/pages/CadTiposOcorrencias.vue")
    }, {
        path: "/tipoOcorrencia",
        name: "tipoOcorrenciaInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "tipoOcorrenciaInc" */ "@/pages/CadTipoOcorrencia.vue")
    }, {
        path: "/tipoOcorrencia/:id",
        name: "tipoOcorrenciaAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "tipoOcorrenciaAlt" */ "@/pages/CadTipoOcorrencia.vue")
    }, {
        path: "/emitentes",
        name: "emitentes", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "emitentes" */ "@/pages/CadEmitentes.vue")
    }, {
        path: "/emitente",
        name: "emitenteInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "emitenteInc" */ "@/pages/CadEmitente.vue")
    }, {
        path: "/emitente/:id",
        name: "emitenteAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "emitenteAlt" */ "@/pages/CadEmitente.vue")
    }, {
        path: "/relatorioEnviosBot",
        name: "relatorioEnviosBot",
        meta: {
            title: "Relatórios de Envios",
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "relatorioEnviosBot" */ "@/pages/RelatorioEnviosBot.vue")
    }, {
        path: "/relatorioConsumoWhatsAppCreditosBot", name: "relatorioConsumoWhatsAppCreditosBot",
        meta: { requiresAuth: true, title: "Consumo de créditos de WhatsApp" },
        props: { canal: "WHATSAPP", tipo: "CONSUMO" },
        component: () => import("@/pages/RelatorioCreditosMensagensBot.vue")
    },
    {
        path: "/relatorioRecargasWhatsAppCreditosBot", name: "relatorioRecargasWhatsAppCreditosBot",
        meta: { requiresAuth: true, title: "Recargas de créditos de WhatsApp" },
        props: { canal: "WHATSAPP", tipo: "RECARGAS" },
        component: () => import("@/pages/RelatorioCreditosMensagensBot.vue")
    },
    {
        path: "/relatorioConsumoSMSCreditosBot", name: "relatorioConsumoSMSCreditosBot",
        meta: { requiresAuth: true, title: "Consumo de créditos de SMS" },
        props: { canal: "SMS", tipo: "CONSUMO" },
        component: () => import("@/pages/RelatorioCreditosMensagensBot.vue")
    },
    {
        path: "/relatorioRecargasSMSCreditosBot", name: "relatorioRecargasSMSCreditosBot",
        meta: { requiresAuth: true, title: "Recargas de créditos de SMS" },
        props: { canal: "SMS", tipo: "RECARGAS" },
        component: () => import("@/pages/RelatorioCreditosMensagensBot.vue")
    },
    {
        path: "/relatorioConsumoIABot",
        name: "relatorioConsumoIABot",
        meta: { title: "Consumo de créditos de IA", requiresAuth: true },
        props: { tipo: "CONSUMO" },
        component: () => import(/* webpackChunkName: "relatorioCreditosIABot" */ "@/pages/RelatorioCreditosIABot.vue")
    }, {
        path: "/recargaCreditosIABot",
        name: "recargaCreditosIABot",
        meta: { title: "Efetuar recarga de créditos", requiresAuth: true },
        component: () => import(/* webpackChunkName: "recargaCreditosIABot" */ "@/pages/RecargaCreditosIABot.vue")
    }, {
        path: "/relatorioRecargasIABot",
        name: "relatorioRecargasIABot",
        meta: { title: "Recargas de créditos de IA", requiresAuth: true },
        props: { tipo: "RECARGAS" },
        component: () => import(/* webpackChunkName: "relatorioCreditosIABot" */ "@/pages/RelatorioCreditosIABot.vue")
    }, {
        path: "/canaisAtendimentoBot", 
        name: "canaisAtendimentoBot", 
        meta: {
            title: "Canais de Atendimento", 
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "canaisAtendimentoBot" */ "@/pages/CanaisAtendimentoBot.vue")
    }, {
        path: "/urasBot",
        name: "urasBot",
        meta: { title: "URAs", requiresAuth: true },
        component: () => import(/* webpackChunkName: "urasBot" */ "@/pages/UrasBot.vue")
    }, {
        path: "/usuariosBot",
        name: "usuariosBot",
        meta: { title: "Usuários do Bot", requiresAuth: true },
        component: () => import(/* webpackChunkName: "usuariosBot" */ "@/pages/UsuariosBot.vue")
    }, {
        path: "/mensagensPersonalizadasBot", 
        name: "mensagensPersonalizadasBot", 
        meta: {
            title: "Mensagens Personalizadas", 
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "mensagensPersonalizadasBot" */ "@/pages/MensagensPersonalizadasBot.vue")
    }, {
        path: "/configuracoesEmailBot",
        name: "configuracoesEmailBot",
        meta: { title: "E-mail (SMTP)", requiresAuth: true },
        component: () => import(/* webpackChunkName: "configuracoesEmailBot" */ "@/pages/ConfiguracoesEmailBot.vue")
    }, {
        path: "/configuracoesGeraisBot", 
        name: "configuracoesGeraisBot", 
        meta: {
            title: "Configurações Gerais do Bot", 
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "configuracoesGeraisBot" */ "@/pages/ConfiguracoesGeraisBot.vue")
    }, {
        path: "/agentesIA", 
        name: "agentesIA", 
        meta: {
            title: "Agentes de IA", 
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "agentesIA" */ "@/pages/AgentesIA.vue")
    }, {
        path: "/regrasEnvio", 
        name: "regrasEnvio", 
        meta: {
            title: "Regras de Envio",
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "regrasEnvio" */ "@/pages/RegrasEnvio.vue")
    }, {
        path: "/regraEnvio", 
        name: "regraEnvio", 
        meta: {
            title: "Regra de Envio", 
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "regrasEnvio" */ "@/pages/RegraEnvio.vue")
    }, {
        path: "/regraEnvio/:id", 
        name: "regraEnvioAlt", 
        meta: {
            title: "Regra de Envio", 
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "regrasEnvio" */ "@/pages/RegraEnvio.vue")
    }, {
        path: "/naturezasOperacao",
        name: "naturezasOperacao", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "naturezasOperacao" */ "@/pages/CadNaturezasOperacao.vue")
    }, {
        path: "/naturezaOperacao",
        name: "naturezaOperacaoInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "naturezaOperacaoInc" */ "@/pages/CadNaturezaOperacao.vue")
    }, {
        path: "/naturezaOperacao/:id",
        name: "naturezaOperacaoAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "naturezaOperacaoAlt" */ "@/pages/CadNaturezaOperacao.vue")
    }, {
        path: "/tiposMulta",
        name: "tiposMulta", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "tiposMulta" */ "@/pages/CadTiposMulta.vue")
    }, {
        path: "/tipoMulta",
        name: "tipoMultaInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "tipoMultaInc" */ "@/pages/CadTipoMulta.vue")
    }, {
        path: "/tipoMulta/:id",
        name: "tipoMultaAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "tipoMultaAlt" */ "@/pages/CadTipoMulta.vue")
    }, {
        path: "/feriados",
        name: "feriados", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "feriados" */ "@/pages/CadFeriados.vue")
    }, {
        path: "/feriado",
        name: "feriadoInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "feriadoInc" */ "@/pages/CadFeriado.vue")
    }, {
        path: "/feriado/:id",
        name: "feriadoAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "feriadoAlt" */ "@/pages/CadFeriado.vue")
    }, {
        path: "/notasFiscais",
        name: "notasFiscais", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "notasFiscais" */ "@/pages/NotasFiscais.vue")
    }, {
        path: "/motivosAusencia",
        name: "motivosAusencia", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "motivosAusencia" */ "@/pages/CadMotivosAusencia.vue")
    }, {
        path: "/motivoAusencia",
        name: "motivoAusenciaInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "motivoAusenciaInc" */ "@/pages/CadMotivoAusencia.vue")
    }, {
        path: "/motivoAusencia/:id",
        name: "motivoAusenciaAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "motivoAusenciaAlt" */ "@/pages/CadMotivoAusencia.vue")
    }, {
        path: "/gerenciadorTemplates/:id", 
        name: "gerenciadorTemplates", 
        meta: {
            title: "Gerenciador de Templates", 
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "gerenciadorTemplates" */ "@/pages/GerenciadorTemplates.vue")
    }, {
        path: "/tiposPendencia",
        name: "tiposPendencia", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "tiposPendencia" */ "@/pages/CadTiposPendencia.vue")
    }, {
        path: "/tipoPendencia",
        name: "tipoPendenciaInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "tipoPendenciaInc" */ "@/pages/CadTipoPendencia.vue")
    }, {
        path: "/tipoPendencia/:id",
        name: "tipoPendenciaAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "tipoPendenciaAlt" */ "@/pages/CadTipoPendencia.vue")
    }, {
        path: "/tiposGlosa",
        name: "tiposGlosa", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "tiposGlosa" */ "@/pages/CadTiposGlosa.vue")
    }, {
        path: "/tipoGlosa",
        name: "tipoGlosaInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "tipoGlosaInc" */ "@/pages/CadTipoGlosa.vue")
    }, {
        path: "/tipoGlosa/:id",
        name: "tipoGlosaAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "tipoGlosaAlt" */ "@/pages/CadTipoGlosa.vue")
    }, {
        path: "/taxasTurno",
        name: "taxasTurno", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "taxasTurno" */ "@/pages/CadTaxasTurno.vue")
    }, {
        path: "/taxaTurno",
        name: "taxaTurnoInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "taxaTurnoInc" */ "@/pages/CadTaxaTurno.vue")
    }, {
        path: "/taxaTurno/:id",
        name: "taxaTurnoAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "taxaTurnoAlt" */ "@/pages/CadTaxaTurno.vue")
    }, {
        path: "/cobrancasConvenio",
        name: "cobrancasConvenio", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "cobrancasConvenio" */ "@/pages/CobrancasConvenio.vue")
    }, {
        path: "/campanhas",
        name: "campanhas",
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "campanhas" */ "@/pages/CadCampanhas.vue")
    }, {
        path: "/campanha",
        name: "campanhaInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "campanhaInc" */ "@/pages/CadCampanha.vue")
    }, {
        path: "/campanha/:id",
        name: "campanhaAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "campanhaAlt" */ "@/pages/CadCampanha.vue")
    }, {
        path: "/kanbans",
        name: "kanbans",
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "kanbans" */ "@/pages/CadKanbans.vue")
    }, {
        path: "/kanban",
        name: "kanbanInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "kanbanInc" */ "@/pages/CadKanban.vue")
    }, {
        path: "/kanban/:id",
        name: "kanbanAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "kanbanAlt" */ "@/pages/CadKanban.vue")
    }, {
        path: "/perfisUsuario",
        name: "perfisUsuario", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "perfisUsuario" */ "@/pages/CadPerfisUsuario.vue")
    }, {
        path: "/perfilUsuario",
        name: "perfilUsuarioInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "perfilUsuarioInc" */ "@/pages/CadPerfilUsuario.vue")
    }, {
        path: "/perfilUsuario/:SISTEMA/:PERFIL",
        name: "perfilUsuarioAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "perfilUsuarioAlt" */ "@/pages/CadPerfilUsuario.vue")
    }, {
        path: "/changeLog",
        name: "changeLog", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "changeLog" */ "@/pages/ChangeLog.vue")
    }, {
        path: "/suporteMicrologos",
        name: "suporteMicrologos", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "suporteMicrologos" */ "@/../../desk-spirit/src/components/suporteMicrologos.vue")
    }, {
        path: "/moedas",
        name: "moedas", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "moedas" */ "@/pages/CadMoedas.vue")
    }, {
        path: "/moeda",
        name: "moedaInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "moedaInc" */ "@/pages/CadMoeda.vue")
    }, {
        path: "/moeda/:id",
        name: "moedaAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "moedaAlt" */ "@/pages/CadMoeda.vue")
    }, {
        path: "/relatorioLeads",
        name: "relatorioLeads", 
        meta: {
            title: "Relatório de Leads", 
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "relatorioLeads" */ "@/pages/RelatorioLeads.vue")
    }, {
        path: "/relatorioTermos",
        name: "relatorioTermos", 
        meta: {
            title: "Relatório de Termos", 
            requiresAuth: true
        }, 
        component: () => import(/* webpackChunkName: "relatorioTermos" */ "@/pages/RelatorioTermos.vue")
    }, {
        path: "/relatorioPacoteSessoes",
        name: "relatorioPacoteSessoes",
        meta: { title: "Relatório de Pacote de Sessões", requiresAuth: true },
        component: () => import(/* webpackChunkName: "relatorioPacoteSessoes" */ "@/pages/RelatorioPacoteSessoes.vue")
    }, {
        path: "/payRecebedores",
        name: "payRecebedores", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "payRecebedores" */ "@/pages/CadPayRecebedores.vue")
    }, {
        path: "/payRecebedor",
        name: "payRecebedorInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "payRecebedorInc" */ "@/pages/CadPayRecebedor.vue")
    }, {
        path: "/payRecebedor/:id",
        name: "payRecebedorAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "payRecebedorAlt" */ "@/pages/CadPayRecebedor.vue")
    }, {
        path: "/payClientes",
        name: "payClientes", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "payClientes" */ "@/pages/CadPayClientes.vue")
    }, {
        path: "/payCliente",
        name: "payClienteInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "payClienteInc" */ "@/pages/CadPayCliente.vue")
    }, {
        path: "/payCliente/:id",
        name: "payClienteAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "payClienteAlt" */ "@/pages/CadPayCliente.vue")
    }, {
        path: "/payMaquininhas", 
        name: "payMaquininhas", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "payMaquininhas" */ "@/pages/CadPayMaquininhas.vue")
    }, {
        path: "/payMaquininha", 
        name: "payMaquininhaInc", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "payMaquininhasInc" */ "@/pages/CadPayMaquininha.vue")
    }, {
        path: "/payMaquininha/:id",
        name: "payMaquininhaAlt", 
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "payMaquininhasAlt" */ "@/pages/CadPayMaquininha.vue")
    }]
});
